/**
 * ============================================================
 * CONFIGURATION GLOBALE DE LA NAVIGATION — VERSION CORRIGÉE
 * ============================================================
 */

// ======================
// NAVIGATION PRINCIPALE
// ======================
export const primaryNavigation = [
  { label: "Acquisition", path: "/acquisition", exact: true },
  { label: "Modeling", path: "/modeling", exact: true },
  { label: "Management", path: "/management", exact: true },
  { label: "Saving", path: "/pdf-uploader", exact: true },
  { label: "Analysis", path: "/analysisbeta", exact: true },
  { label: "Conception", path: "/conception", exact: true },
  { label: "Evaluation", path: "/implementation", exact: true }
];

// ======================
// SOUS-MENUS
// ======================

// 🧩 Modeling views – PDF Uploader retiré
export const modelingViews = [
  { label: "Functional View", path: "/functional-view-1", exact: true },
  { label: "Process View", path: "/process-view-1", exact: true },
  { label: "Physical Model", path: "/physical-model-1", exact: true },
  { label: "Decisional View", path: "/decisional-model-1", exact: true },
  { label: "Information Model", path: "/informational-model-1", exact: true }
];

// 🧰 Management tools
export const leanTools = [
  { label: "VSM", path: "/lean-vsm-1", exact: true },
  { label: "5S", path: "/5s-1", exact: true },
  { label: "Kaizen", path: "/kaizen-1", exact: true },
  { label: "SMED", path: "/smed-1", exact: true },
  { label: "Kanban", path: "/kanban-1", exact: true },
  { label: "Visual Management", path: "/visual-management-1", exact: true }
];

// ======================
// CONFIGURATION PAR SECTION
// ======================
export const navigationConfigs = {
  acquisition: { primary: primaryNavigation, secondary: [] },
  modeling: { primary: primaryNavigation, secondary: modelingViews },
  management: { primary: primaryNavigation, secondary: leanTools },
  analysis: { primary: primaryNavigation, secondary: [] },
  conception: { primary: primaryNavigation, secondary: [] },
  implementation: { primary: primaryNavigation, secondary: [] },
  admin: {
    primary: [
      { label: "Dashboard", path: "/admin", exact: true },
      { label: "Users", path: "/admin/users", exact: true },
      { label: "Enterprises", path: "/admin/enterprises", exact: true },
      { label: "Settings", path: "/admin/settings", exact: true }
    ],
    secondary: []
  }
};

// ======================
// ROUTES ASSOCIÉES PAR DOMAINE
// ======================
const modelingRoutes = [
  "modeling",
  "functional-view",
  "process-view",
  "physical-model",
  "decisional-model",
  "informational-model"
];

// Pas besoin d'ajouter pdf-uploader ici → il n'est plus dans Modeling

const managementRoutes = [
  "management",
  "lean",
  "vsm",
  "5s",
  "kaizen",
  "smed",
  "kanban",
  "visual-management"
];

// ======================
// LOGIQUE D’AFFICHAGE AUTOMATIQUE
// ======================
export const getNavigationConfig = (pathname) => {
  const path = pathname.toLowerCase();

  if (path.startsWith("/acquisition")) return navigationConfigs.acquisition;

  if (modelingRoutes.some((route) => path.includes(route)))
    return navigationConfigs.modeling;

  if (managementRoutes.some((route) => path.includes(route)))
    return navigationConfigs.management;

  if (path.startsWith("/analysis")) return navigationConfigs.analysis;
  if (path.startsWith("/conception")) return navigationConfigs.conception;
  if (path.startsWith("/implementation"))
    return navigationConfigs.implementation;
  if (path.startsWith("/admin")) return navigationConfigs.admin;

  return { primary: primaryNavigation, secondary: [] };
};
